import { FC } from "react";
import { CircularProgress, Stack, Typography } from "@mui/material";

interface FilterValueWithBatchInputSearchingPhaseProps {
  count: number;
}

export const FilterValueWithBatchInputSearchingPhase: FC<
  FilterValueWithBatchInputSearchingPhaseProps
> = ({ count }) => {
  return (
    <Stack height={320} alignItems="center" justifyContent="center">
      <CircularProgress size={22} />
      <Typography mt={1}>
        Searching{" "}
        <Typography component="span" fontWeight="bold">
          {count}
        </Typography>{" "}
        values...
      </Typography>
    </Stack>
  );
};
